import ReactPixel, { Options } from 'react-facebook-pixel';

// default events. More info about standard events: https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#standard-events
export enum FACEBOOK_PIXEL_EVENTS {
  Contact = 'Contact',
}

const fbPixel = {
  initFacebookPixel() {
    const options = {
      autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
      debug: process.env.REACT_APP_ENV !== 'production', // enable logs
    } as Options;

    if (!process.env.REACT_APP_FACEBOOK_PIXEL_ID) {
      console.error('Facebook Pixel ID is not set');
      return;
    }

    ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID, undefined, options);
    ReactPixel.grantConsent();
  },
  trackContact(email: string) {
    ReactPixel.track(FACEBOOK_PIXEL_EVENTS.Contact, { email });
  },
};

fbPixel.initFacebookPixel();
export default fbPixel;
